import { Component, OnInit, ViewChild } from '@angular/core';
import * as XLSX from 'xlsx';
import { Subject } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PartnerService } from '../../../../services/partner.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { HelpersService } from '../../../../services/helpers.service';
import moment from 'moment';

@Component({
  selector: 'app-service-imports',
  templateUrl: './service-imports.component.html',
  styleUrls: ['./service-imports.component.scss'],
})
export class ServiceImportsComponent implements OnInit {
  public keys: string[];
  public dataSheet = new Subject();
  public data: any = [];
  public importData: any = [];
  public servicesTypes: any = [];
  public isExcelFile: boolean;
  public needsBookingStartDate: boolean = false;
  public needsForceBookingOption: boolean = false;
  public hasValidationErrors: boolean = false;
  public invalidFileFormat: boolean = false;
  public sendCommunication: boolean = false;
  public forceBookingToScheduledDate: boolean = false;
  public importing: boolean = false;
  public startDate: Date = null;
  public countryData: any = {};
  public progress: number = 0;
  public step = 1;
  @ViewChild('fileUpload') fileUpload: any;
  public columns: any = [
    {
      header: this.translate.instant('general.headers.customer'),
      field: 'Customer',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.email'),
      field: 'Email',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.phone_number'),
      field: 'PhoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.services'),
      field: 'ServiceType',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.dates'),
      field: 'DateSummary',
      type: 'dateSummary',
    },
    {
      header: this.translate.instant('general.headers.bike_build'),
      field: 'BikeBuild',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.bike_summary'),
      field: 'BikeSummary',
      type: 'bikeSummary',
    },
    {
      header: this.translate.instant('general.headers.other_info'),
      field: 'Notes',
      type: 'notes',
    },
    {
      header: this.translate.instant('general.headers.status'),
      field: 'Status',
      type: 'status',
    },
  ];

  public columnsImported: any = [
    {
      header: this.translate.instant('general.headers.customer'),
      field: 'Customer',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.email'),
      field: 'Email',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.phone_number'),
      field: 'PhoneNumber',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.services'),
      field: 'ServiceType',
      type: 'string',
    },
    {
      header: this.translate.instant('general.headers.bike_summary'),
      field: 'BikeSummary',
      type: 'bikeSummary',
    },
    {
      header: this.translate.instant('general.headers.other_info'),
      field: 'Notes',
      type: 'notes',
    },
    {
      header: this.translate.instant('general.headers.job_card_no'),
      field: 'JobCardNo',
      type: 'string',
    },
    {
      header: this.translate.instant(
        'bikeshop.modal.update_job_card.job_card.scheduled_date',
      ),
      field: 'BookedInDate',
      type: 'date',
    },
    {
      header: this.translate.instant('general.headers.status'),
      field: 'Status',
      type: 'status',
    },
  ];

  constructor(
    public router: Router,
    private translate: TranslateService,
    private partnerService: PartnerService,
    private helpersService: HelpersService,
    private serviceRequest: ServiceRequestService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    this.getServiceTypes();
  }

  getServiceTypes() {
    this.partnerService
      .getPartnerServiceTypesFull(this.helpersService.getPartnerId())
      .subscribe((servicesTypes) => {
        this.servicesTypes = servicesTypes;
      });
  }

  prepareFile(evt) {
    let data, header;

    const target: DataTransfer = <DataTransfer>evt.target;
    this.isExcelFile = !!target.files[0].name.match(/(.xls|.xlsx)/);
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      data = XLSX.utils.sheet_to_json(ws, { raw: false, defval: null });
    };

    reader.readAsBinaryString(target.files[0]);

    reader.onloadend = (e) => {
      this.keys = Object.keys(data[0]);
      this.dataSheet.next(data);
      /*this.dataSheet.subscribe(sheetData=>{
                    this.processFile(sheetData);
                  });*/
      this.processFile(data);
    };
    this.fileUpload.nativeElement.value = '';
  }

  processFile(data) {
    this.invalidFileFormat = false;
    this.needsBookingStartDate = false;
    this.hasValidationErrors = false;
    this.needsForceBookingOption = false;
    this.startDate = null;
    console.log(this.keys);
    console.log(data);
    if (
      this.keys.indexOf('Customer Name') > -1 &&
      this.keys.indexOf('Customer Surname') > -1 &&
      this.keys.indexOf('Customer Email') > -1 &&
      this.keys.indexOf('Customer Phone Number') > -1 &&
      this.keys.indexOf('Bike Manufacturer') > -1
    ) {
      this.step = 2;
      this.processHubtigerTemplate(data);
    } else if (
      this.keys.indexOf('Hybris Order#') > -1 &&
      this.keys.indexOf('Order Number') > -1 &&
      this.keys.indexOf('Item Number') > -1 &&
      this.keys.indexOf('Email Address') > -1 &&
      this.keys.indexOf('Description') > -1 &&
      this.keys.indexOf('Postal Code') > -1 &&
      this.keys.indexOf('Model') > -1 &&
      this.keys.indexOf('Ship-To Addr1') > -1
    ) {
      this.step = 2;
      this.processSpecializedUKTemplate(data);
    } else if (
      this.keys.indexOf('Order Number') > -1 &&
      this.keys.indexOf('Item Number') > -1 &&
      this.keys.indexOf('Email Address') > -1 &&
      this.keys.indexOf('Description') > -1 &&
      this.keys.indexOf('Serial #') > -1 &&
      this.keys.indexOf('Customer Name') > -1 &&
      this.keys.indexOf('Phone #') > -1 &&
      this.keys.indexOf('Pedals Included') > -1
    ) {
      this.step = 2;
      this.processSpecializedGeneralTemplate(data);
    } else {
      this.invalidFileFormat = true;
    }
  }

  processHubtigerTemplate(data) {
    var sheetData = [];
    data.forEach((row) => {
      var validation = this.validateRow(row);
      var valid = validation === 'Valid';

      sheetData.push({
        BusinessAccount:
          row['Business Account'] === null ||
          row['Business Account'] === undefined ||
          row['Business Account'].length === 0
            ? false
            : row['Business Account'].toLowerCase() === 'yes' ||
                row['Business Account'].toLowerCase() === 'true'
              ? true
              : false,
        Customer:
          row['Customer Name'] && row['Customer Surname']
            ? row['Customer Name'] + ' ' + row['Customer Surname']
            : row['Customer Name']
              ? row['Customer Name']
              : row['Customer Surname']
                ? row['Customer Surname']
                : '',
        Name: row['Customer Name'] || null,
        Surname: row['Customer Surname'] || null,
        Email: row['Customer Email'] || null,
        PhoneNumber: row['Customer Phone Number'] || null,
        ServiceType: row['Service Type'] || null,
        LinkedServices: valid ? this.linkedServices(row) : [],
        BikeBuild:
          row['Bike Build'] === null ||
          row['Bike Build'] === undefined ||
          row['Bike Build'].length === 0
            ? false
            : row['Bike Build'].toLowerCase() === 'yes' ||
                row['Bike Build'].toLowerCase() === 'true'
              ? true
              : false,
        ScheduleDate:
          row['Booking Date'] === null ||
          row['Booking Date'] === undefined ||
          row['Booking Date'].length === 0
            ? null
            : moment(row['Booking Date']).format('YYYY-MM-DD'),
        RequiredBy:
          row['Required By Date'] === null ||
          row['Required By Date'] === undefined ||
          row['Required By Date'].length === 0
            ? null
            : moment(row['Required By Date']).format('YYYY-MM-DD'),
        DateSummary: !valid
          ? '-'
          : '<li>' +
            this.translate.instant('general.headers.scheduled') +
            ': ' +
            (row['Booking Date'] === null ||
            row['Booking Date'] === undefined ||
            row['Booking Date'].length === 0
              ? this.translate.instant(
                  'bikeshop.service_imports.slot_will_be_selected',
                )
              : moment(row['Booking Date']).format(
                  this.countryData.MomentDateFormat,
                )) +
            '</li>' +
            ('<li>' +
              this.translate.instant(
                'bikeshop.modal.shedule_service.required_by',
              ) +
              ': ' +
              (row['Required By Date'] === null ||
              row['Required By Date'] === undefined ||
              row['Required By Date'].length === 0
                ? '-'
                : moment(row['Required By Date']).format(
                    this.countryData.MomentDateFormat,
                  )) +
              '</li>'),
        BikeSummary:
          (row['Bike Manufacturer'] !== null &&
          row['Bike Manufacturer'] !== undefined
            ? '<li>' + row['Bike Manufacturer'] + '</li>'
            : '') +
          (row['Bike Model'] !== null && row['Bike Model'] !== undefined
            ? '<li>' + row['Bike Model'] + '</li>'
            : '') +
          (row['Bike Year'] !== null && row['Bike Year'] !== undefined
            ? '<li>' + row['Bike Year'] + '</li>'
            : '') +
          (row['Bike Color'] !== null && row['Bike Color'] !== undefined
            ? '<li>' + row['Bike Color'] + '</li>'
            : '') +
          (row['Serial Number'] !== null && row['Serial Number'] !== undefined
            ? '<li>' + row['Serial Number'] + '</li>'
            : ''),
        Manufacturer: row['Bike Manufacturer'] || null,
        Model: row['Bike Model'] || null,
        Year: row['Bike Year'] || null,
        Color: row['Bike Color'] || null,
        SerialNumber: row['Serial Number'] || null,
        Notes: row['Notes'] || null,
        Status: validation,
      });
      if (!valid) {
        this.hasValidationErrors = true;
      }
      if (
        valid &&
        (row['Booking Date'] === null ||
          row['Booking Date'] === undefined ||
          row['Booking Date'].length === 0)
      ) {
        this.needsBookingStartDate = true;
      }
      if (
        valid &&
        row['Booking Date'] !== null &&
        row['Booking Date'] !== undefined &&
        row['Booking Date'].length > 0
      ) {
        this.needsForceBookingOption = true;
      }
    });

    this.data = sheetData;
  }

  processSpecializedUKTemplate(data) {
    var sheetData = [];
    data.forEach((row) => {
      row['Service Type'] = 'Bike Build';
      row['Customer Email'] = row['Email Address'];

      var validation = this.validateRow(row);
      var valid = validation === 'Valid';
      sheetData.push({
        BusinessAccount: true,
        Customer: row['Ship-To Addr1'] ? row['Ship-To Addr1'] : '',
        Name: row['Ship-To Addr1'] || null,
        Surname: null,
        Email: row['Email Address'] || null,
        PhoneNumber: row['Phone Number'] || null,
        ServiceType: row['Service Type'] || null,
        LinkedServices: valid ? this.linkedServices(row) : [],
        BikeBuild: true,
        ScheduleDate: null,
        RequiredBy:
          row['Required By Date'] === null ||
          row['Required By Date'] === undefined ||
          row['Required By Date'].length === 0
            ? null
            : moment(row['Required By Date']).format('YYYY-MM-DD'),
        DateSummary: !valid
          ? '-'
          : '<li>' +
            this.translate.instant('general.headers.scheduled') +
            ': ' +
            (row['Booking Date'] === null ||
            row['Booking Date'] === undefined ||
            row['Booking Date'].length === 0
              ? this.translate.instant(
                  'bikeshop.service_imports.slot_will_be_selected',
                )
              : moment(row['Booking Date']).format(
                  this.countryData.MomentDateFormat,
                )) +
            '</li>' +
            ('<li>' +
              this.translate.instant(
                'bikeshop.modal.shedule_service.required_by',
              ) +
              ': ' +
              (row['Required By Date'] === null ||
              row['Required By Date'] === undefined ||
              row['Required By Date'].length === 0
                ? '-'
                : moment(row['Required By Date']).format(
                    this.countryData.MomentDateFormat,
                  )) +
              '</li>'),
        BikeSummary:
          '<li>' +
          'Specialized' +
          '</li>' +
          (row['Model'] !== null && row['Model'] !== undefined
            ? '<li>' + row['Model'] + '</li>'
            : '') +
          (row['Year'] !== null && row['Year'] !== undefined
            ? '<li>' + row['Year'] + '</li>'
            : '') +
          (row['Serial Number'] !== null && row['Serial Number'] !== undefined
            ? '<li>' + row['Serial Number'] + '</li>'
            : ''),
        Manufacturer: 'Specialized' || null,
        Model: row['Model'] || null,
        Year: row['Year'] || null,
        Color: null,
        SerialNumber: row['Serial Number'] || null,
        Notes:
          'Hybris Order #: ' +
          (row['Hybris Order#'] || '') +
          '<br>' +
          'Order Number: ' +
          (row['Order Number'] || '') +
          '<br>' +
          'Item Number: ' +
          (row['Item Number'] || '') +
          '<br>' +
          'Bike: ' +
          (row['Description'] || '') +
          '<br>' +
          'Postal Code: ' +
          (row['Postal Code'] || '') +
          '<br>',
        UniqueExternalValue: row['Order Number'] || null,
        UniqueExternalValueOther:
          row['Line Number'] || row['Line number'] || null,
        Status: validation,
      });
      if (!valid) {
        this.hasValidationErrors = true;
      }
      if (
        valid &&
        (row['Booking Date'] === null ||
          row['Booking Date'] === undefined ||
          row['Booking Date'].length === 0)
      ) {
        this.needsBookingStartDate = true;
      }
      if (
        valid &&
        row['Booking Date'] !== null &&
        row['Booking Date'] !== undefined &&
        row['Booking Date'].length > 0
      ) {
        this.needsForceBookingOption = true;
      }
    });

    this.data = sheetData;
  }

  processSpecializedGeneralTemplate(data) {
    var sheetData = [];
    data.forEach((row) => {
      row['Service Type'] = row['Category'];
      row['Customer Email'] = row['Email Address'];

      var validation = this.validateRow(row);
      var valid = validation === 'Valid';
      sheetData.push({
        BusinessAccount: true,
        Customer: row['Customer Name'] || null,
        Name: row['Customer Name'] ? row['Customer Name'].split(' ')[0] : null,
        Surname: row['Customer Name']
          ? row['Customer Name']
              .substring(
                row['Customer Name'].indexOf(' '),
                row['Customer Name'].length,
              )
              .trim()
          : null,
        Email: row['Email Address'] || null,
        PhoneNumber: row['Phone #'] || null,
        ServiceType: row['Service Type'] || null,
        LinkedServices: valid ? this.linkedServices(row) : [],
        BikeBuild: true,
        ScheduleDate: null,
        RequiredBy:
          row['Required By Date'] === null ||
          row['Required By Date'] === undefined ||
          row['Required By Date'].length === 0
            ? null
            : moment(row['Required By Date']).format('YYYY-MM-DD'),
        DateSummary: !valid
          ? '-'
          : '<li>' +
            this.translate.instant('general.headers.scheduled') +
            ': ' +
            (row['Booking Date'] === null ||
            row['Booking Date'] === undefined ||
            row['Booking Date'].length === 0
              ? this.translate.instant(
                  'bikeshop.service_imports.slot_will_be_selected',
                )
              : moment(row['Booking Date']).format(
                  this.countryData.MomentDateFormat,
                )) +
            '</li>' +
            ('<li>' +
              this.translate.instant(
                'bikeshop.modal.shedule_service.required_by',
              ) +
              ': ' +
              (row['Required By Date'] === null ||
              row['Required By Date'] === undefined ||
              row['Required By Date'].length === 0
                ? '-'
                : moment(row['Required By Date']).format(
                    this.countryData.MomentDateFormat,
                  )) +
              '</li>'),
        BikeSummary:
          '<li>' +
          'Specialized' +
          '</li>' +
          (row['Model'] !== null && row['Model'] !== undefined
            ? '<li>' + row['Model'] + '</li>'
            : '') +
          (row['Year'] !== null && row['Year'] !== undefined
            ? '<li>' + row['Year'] + '</li>'
            : '') +
          (row['Serial #'] !== null && row['Serial #'] !== undefined
            ? '<li>' + row['Serial #'] + '</li>'
            : ''),
        Manufacturer: 'Specialized' || null,
        Model: row['Model'] || null,
        Year: row['Year'] || null,
        Color: null,
        SerialNumber: row['Serial #'] || null,
        Notes:
          'Hybris Order #: ' +
          (row['Hybris Order#'] || '') +
          '<br>' +
          'Order Number: ' +
          (row['Order Number'] || '') +
          '<br>' +
          'Item Number: ' +
          (row['Item Number'] || '') +
          '<br>' +
          'Waybill #: ' +
          (row['Waybill #'] || '') +
          '<br>' +
          'Delivery Type: ' +
          (row['Delivery Type'] || '') +
          '<br>' +
          'Bike: ' +
          (row['Description'] || '') +
          '<br>' +
          'Pedals Included: ' +
          (row['Pedals Included'] || '') +
          '<br>',
        UniqueExternalValue: row['Order Number'] || null,
        UniqueExternalValueOther:
          row['Line Number'] || row['Line number'] || null,
        Status: validation,
      });
      if (!valid) {
        this.hasValidationErrors = true;
      }
      if (
        valid &&
        (row['Booking Date'] === null ||
          row['Booking Date'] === undefined ||
          row['Booking Date'].length === 0)
      ) {
        this.needsBookingStartDate = true;
      }
      if (
        valid &&
        row['Booking Date'] !== null &&
        row['Booking Date'] !== undefined &&
        row['Booking Date'].length > 0
      ) {
        this.needsForceBookingOption = true;
      }
    });

    this.data = sheetData;
  }

  linkedServices(row) {
    var linkedServiceTypes = [];
    var serviceTypes =
      row['Service Type'].indexOf(';') > -1
        ? row['Service Type'].split(';')
        : row['Service Type'].indexOf(',') > -1
          ? row['Service Type'].split(',')
          : row['Service Type'].split(';');
    serviceTypes.forEach((serviceType) => {
      var match = this.servicesTypes
        .filter((x) => {
          return (
            x.ServiceTypeDescription.trim().toLowerCase() ===
            serviceType.trim().toLowerCase()
          );
        })
        .pop();
      if (match !== null) {
        linkedServiceTypes.push(match.ID);
      }
    });
    return linkedServiceTypes;
  }

  validateRow(row) {
    var message = '';
    if (
      (row['Customer Email'] === null ||
        row['Customer Email'] === undefined ||
        row['Customer Email'].length === 0) &&
      (row['Customer Phone Number'] === null ||
        row['Customer Phone Number'] === undefined ||
        row['Customer Phone Number'].length === 0)
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.service_imports.errors.no_phone_email',
        ) +
        '</li>';
    }
    if (
      row['Customer Email'] !== null &&
      row['Customer Email'] !== undefined &&
      row['Customer Email'].length > 0 &&
      !row['Customer Email'].match(
        /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
      )
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.service_imports.errors.email_invalid',
        ) +
        '</li>';
    }
    if (
      row['Service Type'] === null ||
      row['Service Type'] === undefined ||
      row['Service Type'].length === 0
    ) {
      message +=
        '<li>' +
        this.translate.instant(
          'bikeshop.service_imports.errors.no_service_types',
        ) +
        '</li>';
    } else {
      var serviceTypes =
        row['Service Type'].indexOf(';') > -1
          ? row['Service Type'].split(';')
          : row['Service Type'].indexOf(',') > -1
            ? row['Service Type'].split(',')
            : row['Service Type'].split(';');
      var invalidServiceType = false;
      serviceTypes.forEach((serviceType) => {
        var match = this.servicesTypes
          .filter((x) => {
            return (
              x.ServiceTypeDescription.trim().toLowerCase() ===
              serviceType.trim().toLowerCase()
            );
          })
          .pop();
        if (match === undefined || match === null) {
          invalidServiceType = true;
        }
      });
      if (invalidServiceType) {
        message +=
          '<li>' +
          this.translate.instant(
            'bikeshop.service_imports.errors.invalid_service_type',
          ) +
          '</li>';
      }
    }
    return message === '' ? 'Valid' : message;
  }

  resetWizard() {
    this.invalidFileFormat = false;
    this.needsBookingStartDate = false;
    this.hasValidationErrors = false;
    this.needsForceBookingOption = false;
    this.startDate = null;
    this.keys = [];
    this.data = [];
    this.step = 1;
  }

  downloadTemplate() {
    window.open('/assets/excel-tempates/Job Import Template.xlsx');
  }

  beginImport() {
    this.importData = [];
    this.progress = 0;

    this.data = this.data
      .filter((x) => {
        return x.Status === 'Valid';
      })
      .map((data, index) => {
        return { ...data, Index: index + 1, Status: null };
      });

    //Do any jobs with required date first
    if (
      this.data.filter((x) => {
        return x.RequiredBy != null;
      }).length > 0
    ) {
      this.data
        .filter((x) => {
          return x.RequiredBy != null;
        })
        .sort((x, y) => {
          if (x.RequiredBy < y.RequiredBy) return -1;
          if (x.RequiredBy > y.RequiredBy) return 1;
          return 0;
        })
        .forEach((x) => {
          this.importData.push(x);
        });
    }

    //Do any jobs with dates next
    if (
      this.data.filter((x) => {
        return x.ScheduleDate !== null && x.RequiredBy === null;
      }).length > 0
    ) {
      this.data
        .filter((x) => {
          return x.ScheduleDate !== null && x.RequiredBy === null;
        })
        .sort((x, y) => {
          if (x.ScheduleDate < y.ScheduleDate) return -1;
          if (x.ScheduleDate > y.ScheduleDate) return 1;
          return 0;
        })
        .forEach((x) => {
          this.importData.push(x);
        });
    }

    //Lastly, do any jobs with no dates or required by dates
    if (
      this.data.filter((x) => {
        return x.ScheduleDate === null && x.RequiredBy === null;
      }).length > 0
    ) {
      this.data
        .filter((x) => {
          return x.ScheduleDate === null && x.RequiredBy === null;
        })
        .sort((x, y) => {
          if (x.Index < y.Index) return -1;
          if (x.Index > y.Index) return 1;
          return 0;
        })
        .forEach((x) => {
          this.importData.push(x);
        });
    }
    this.step = 3;
    this.importing = true;

    this.pushDataToHubtiger();
  }

  pushDataToHubtiger() {
    var data = {
      StartDate: this.startDate
        ? moment(this.startDate).format('YYYY-MM-DD')
        : null,
      ForceBookingToScheduledDate: this.forceBookingToScheduledDate,
      SendCommunication: this.sendCommunication,
      Bookings: this.importData
        .filter((x) => {
          return x.Status === null;
        })
        .splice(0, 4),
    };

    this.serviceRequest
      .importServices(this.helpersService.getPartnerId(), data)
      .subscribe(
        (bookings) => {
          bookings.forEach((booking) => {
            var found = this.importData
              .filter((x) => x.Index === booking.Index)
              .pop();
            if (found !== null && found !== undefined) {
              found.BookedInDate = booking.BookedInDate;
              found.JobCardNo = booking.JobCardNo;
              found.Status = booking.Status;
            }
          });
          this.progress = Math.round(
            (this.importData.filter((x) => {
              return x.Status !== null;
            }).length /
              this.importData.length) *
              100,
          );

          if (
            this.importData.filter((x) => {
              return x.Status === null;
            }).length > 0
          ) {
            this.pushDataToHubtiger();
          } else {
            this.importing = false;
          }
        },
        (err) => {
          this.importing = false;
        },
      );
  }
}
